module.exports = __webpack_public_path__ + "static/img/li1_16.58542536.png";